/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Report_Material_TranscriptInputs */



/**
* | output |
* | --- |
* | "Notetaker transcript" |
*
* @param {Meeting_Report_Material_TranscriptInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_material_transcript = /** @type {((inputs?: Meeting_Report_Material_TranscriptInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_Material_TranscriptInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Transcript van de notetaker")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transcription du notetaker")
	return /** @type {LocalizedString} */ ("Notetaker transcript")
});